import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ProductosComponent } from './productos/productos.component';
import { VentasComponent } from './ventas/ventas.component';
import { InicioComponent } from './inicio/inicio.component';
import { SharedModule } from './shared/shared.module';
import { AngularMaterialModule } from './angularMaterial.module';
import { LoginComponent } from './login/login.component';
import { ProductoDialogComponent } from './productos/product-dialog/product-dialog.component';
import { TableGenericComponent } from './table-generic/table-generic.component';
import { SuppliersComponent } from './suppliers/suppliers.component';
import { SuppliersDialogComponent } from './suppliers/suppliers-dialog/suppliers-dialog.component';
import { VentasDialogComponent } from './ventas/ventas-dialog/ventas-dialog.component';
import { PipesModule } from './pipesModule.module';
import { UsersDialogComponent } from './login/users-dialog/users-dialog.component';
import { AuthInterceptor } from './services/auth.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReportGeneratorComponent } from './report-generator/report-generator.component';
import { InicioAdaptativoComponent } from './inicio/inicio-adaptativo/inicio-adaptativo.component';
import { InicioMobileComponent } from './inicio/movil-version/inicio-mobile.component';
import { AppMobileComponent } from './app-mobile/app-mobile.component';
import { LayoutModule } from '@angular/cdk/layout';
import { ProductDetailDialogComponent } from './inicio/movil-version/product-detail-dialog/product-detail-dialog.component';
import { VentasDialogMobileComponent } from './ventas/ventas-dialog/ventas-dialog-mobile/ventas-dialog-mobile.component';
import { SupplierReportComponent } from './report-generator/supplier-report/supplier-report.component';
import { CortesProveedorComponent } from './cortes-proveedor/cortes-proveedor.component';
import { CortesListaComponent } from './cortes-lista/cortes-lista.component';
import { CortesDialogComponent } from './cortes-lista/cortes-dialog/cortes-dialog.component';
import { CortesDialogMobileComponent } from './cortes-lista/cortes-dialog/cortes-dialog-mobile/cortes-dialog-mobile.component';
import { SearchDialogComponent } from './shared/search-dialog/search-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ProduccionComponent } from './produccion/produccion.component';
import { RestockDialogComponent } from './produccion/restock-dialog/restock-dialog.component';
import { LowStockNotificationComponent } from './shared/low-stock/low-stock-notification.component';
import { LowStockSheetComponent } from './shared/low-stock/low-stock-sheet.component';
import { CorteCajaComponent } from './corte-caja/corte-caja.component';
import { CorteCajaDialogComponent } from './corte-caja/corte-caja-dialog/corte-caja-dialog.component';
import { HistorialInventarioComponent } from './historial-inventario/historial-inventario.component';


@NgModule({
  declarations: [
    AppComponent,
    ProductosComponent,
    VentasComponent,
    InicioAdaptativoComponent,
    InicioComponent,
    InicioMobileComponent,
    LoginComponent,
    ProductoDialogComponent,
    TableGenericComponent,
    SuppliersComponent,
    SuppliersDialogComponent,
    VentasDialogComponent,
    UsersDialogComponent,
    ReportGeneratorComponent,
    AppMobileComponent,
    ProductDetailDialogComponent,
    SupplierReportComponent,
    VentasDialogMobileComponent,
    CortesProveedorComponent,
    CortesListaComponent,
    CortesDialogComponent,
    CortesDialogMobileComponent,
    SearchDialogComponent,
    ProduccionComponent,
    RestockDialogComponent,
    LowStockNotificationComponent,
    LowStockSheetComponent,
    CorteCajaComponent,
    CorteCajaDialogComponent,
    HistorialInventarioComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularMaterialModule,
    SharedModule,
    PipesModule,
    LayoutModule,
    ReactiveFormsModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
